import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

export default function MarqueeStrip() {
  const { t } = useLang();
  return (
    <section aria-hidden="true" className="border-y border-brand-border bg-brand-surface py-6 md:py-8">
      <Marquee speed={40} gradient={false} autoFill>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-4xl leading-[1.35] text-brand-ink/15 md:text-6xl">
            <span className="pb-[0.12em]">{item}</span>
            <span className="text-brand-warm/40">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
